<template>
  <v-container class="fill-height register-container" fluid>
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="8" md="5" lg="4" xl="3">
        <div class="text-center mb-8">
          <v-avatar color="white" size="80" class="mb-4 brand-logo">
            <span class="text-h4 font-weight-bold text-primary">LT</span>
          </v-avatar>
          <h1 class="text-h4 font-weight-bold text-white mb-2">Create Account</h1>
          <p class="text-body-1 text-white-70">Register a new admin account</p>
        </div>

        <v-card class="register-card pa-6" elevation="24">
          <v-form @submit.prevent="register">
            <v-text-field
              v-model="username"
              label="Username"
              prepend-inner-icon="mdi-account-outline"
              variant="outlined"
              density="comfortable"
              class="mb-4"
              hide-details="auto"
            ></v-text-field>

            <v-text-field
              v-model="password"
              label="Password"
              prepend-inner-icon="mdi-lock-outline"
              type="password"
              variant="outlined"
              density="comfortable"
              class="mb-2"
              hide-details="auto"
            ></v-text-field>

            <v-slide-y-transition>
              <v-alert
                v-if="error"
                type="error"
                variant="tonal"
                density="compact"
                class="mb-4 mt-4"
                closable
                @click:close="error = ''"
              >
                {{ error }}
              </v-alert>
            </v-slide-y-transition>

            <v-slide-y-transition>
              <v-alert
                v-if="success"
                type="success"
                variant="tonal"
                density="compact"
                class="mb-4 mt-4"
              >
                Registration successful! Redirecting to login...
              </v-alert>
            </v-slide-y-transition>

            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              class="mt-6 register-btn"
              :disabled="!username || !password"
            >
              <v-icon start>mdi-account-plus</v-icon>
              Register
            </v-btn>
          </v-form>
        </v-card>

        <p class="text-center mt-6 text-white-70 text-body-2">
          Already have an account?
          <router-link to="/" class="text-white font-weight-medium">Login here</router-link>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { authService } from '../services';

const router = useRouter();
const username = ref('');
const password = ref('');
const error = ref('');
const success = ref(false);

async function register() {
  error.value = '';
  success.value = false;
  try {
    await authService.register(username.value, password.value);
    success.value = true;
    setTimeout(() => router.push('/'), 1500);
  } catch (err) {
    error.value = err.response?.data?.error || 'Registration failed';
  }
}
</script>

<style scoped>
.register-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.brand-logo {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.text-white-70 {
  color: rgba(255, 255, 255, 0.7);
}

.register-card {
  border-radius: 20px !important;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95) !important;
}

.register-btn {
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  border-radius: 12px !important;
}

.register-card :deep(.v-field) {
  border-radius: 12px !important;
}

.register-card :deep(.v-field--focused) {
  border-color: #6366f1 !important;
}
</style> 